<!-- ============================================= -->
<!-- CONTENIDO DEL MODAL -->
<!-- ============================================= -->

<ng-template #contenidoModal>

  <!-- HEADER -->

  <header class="app-modal-header" *ngIf="!hideHeader">

    <div class="app-modal-header-content">

      <span
        *ngIf="badgeText"
        class="app-modal-badge">

        {{ badgeText }}

      </span>

      <div class="app-modal-heading">

        <h2
          *ngIf="titleText"
          id="modal-global-title"
          class="app-modal-title">

          {{ titleText }}

        </h2>

        <p
          *ngIf="descriptionText"
          id="modal-global-description"
          class="app-modal-description">

          {{ descriptionText }}

        </p>

      </div>

    </div>

    <button
      type="button"
      class="app-modal-close"
      [disabled]="disableClose"
      (click)="closeModal()"
      aria-label="Cerrar modal">

      <mat-icon>close</mat-icon>

    </button>

  </header>

  <!-- BODY -->

  <section class="app-modal-body">

    <ng-content select="[modalBody]"></ng-content>

  </section>

  <!-- FOOTER -->

  <footer class="app-modal-footer">

    <ng-content select="[modalFooter]"></ng-content>

  </footer>

</ng-template>

<!-- ============================================= -->
<!-- MODO MATDIALOG -->
<!-- ============================================= -->

<ng-container *ngIf="isOpen && usarMatDialog">

  <div
    #modalPanel
    class="app-modal app-modal-dialog"
    [ngClass]="claseTamano">

    <ng-container
      *ngTemplateOutlet="contenidoModal">
    </ng-container>

  </div>

</ng-container>

<!-- ============================================= -->
<!-- MODO STANDALONE -->
<!-- ============================================= -->

<ng-container *ngIf="isOpen && !usarMatDialog">

  <div
    *ngIf="useBackdrop"
    class="app-modal-backdrop"
    (click)="onBackdropClick()">

    <div
      #modalPanel
      class="app-modal"
      [ngClass]="claseTamano"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleText ? 'modal-global-title' : null"
      [attr.aria-describedby]="descriptionText ? 'modal-global-description' : null"
      (click)="$event.stopPropagation()">

      <ng-container
        *ngTemplateOutlet="contenidoModal">
      </ng-container>

    </div>

  </div>

  <!-- EMBEBIDO -->

  <div
    *ngIf="!useBackdrop"
    #modalPanel
    class="app-modal"
    [ngClass]="claseTamano">

    <ng-container
      *ngTemplateOutlet="contenidoModal">
    </ng-container>

  </div>

</ng-container>